module.exports = __webpack_public_path__ + "static/img/ad2.821e0c2c.png";